/* tslint:disable */
import {
  ScreenCategory,
  Screen,
  ScheduleTimeframe,
  CategoryRotation,
  LayoutPanel
} from '../index';

declare var Object: any;
export interface RotationItemInterface {
  "id": string;
  "enabled": boolean;
  "random": boolean;
  "positionIndex": number;
  "screensPerPlay": number;
  "dwellTime": number;
  "transition"?: string;
  "triggerable": boolean;
  "inScheduleWhenTriggerEnabled": boolean;
  "conditions"?: any;
  "metadata"?: any;
  "screenCategoryId"?: string;
  "ownerScreenCategoryId"?: string;
  "screenId"?: string;
  "categoryRotationId"?: string;
  "createdByIp": string;
  "lastUpdatedByIp": string;
  "createdAt": Date;
  "updatedAt": Date;
  "layoutPanelId"?: string;
  "layoutPanelOverlayId"?: string;
  screenCategory?: ScreenCategory;
  ownerScreenCategory?: ScreenCategory;
  screen?: Screen;
  scheduleTimeframes?: ScheduleTimeframe[];
  categoryRotation?: CategoryRotation;
  layoutPanel?: LayoutPanel;
}

export class RotationItem implements RotationItemInterface {
  "id": string;
  "enabled": boolean;
  "random": boolean;
  "positionIndex": number;
  "screensPerPlay": number;
  "dwellTime": number;
  "transition": string;
  "triggerable": boolean;
  "inScheduleWhenTriggerEnabled": boolean;
  "conditions": any;
  "metadata": any;
  "screenCategoryId": string;
  "ownerScreenCategoryId": string;
  "screenId": string;
  "categoryRotationId": string;
  "createdByIp": string;
  "lastUpdatedByIp": string;
  "createdAt": Date;
  "updatedAt": Date;
  "layoutPanelId": string;
  "layoutPanelOverlayId": string;
  screenCategory: ScreenCategory;
  ownerScreenCategory: ScreenCategory;
  screen: Screen;
  scheduleTimeframes: ScheduleTimeframe[];
  categoryRotation: CategoryRotation;
  layoutPanel: LayoutPanel;
  constructor(data?: RotationItemInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `RotationItem`.
   */
  public static getModelName() {
    return "RotationItem";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of RotationItem for dynamic purposes.
  **/
  public static factory(data: RotationItemInterface): RotationItem{
    return new RotationItem(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'RotationItem',
      plural: 'RotationItems',
      path: 'RotationItems',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'string'
        },
        "enabled": {
          name: 'enabled',
          type: 'boolean',
          default: true
        },
        "random": {
          name: 'random',
          type: 'boolean',
          default: false
        },
        "positionIndex": {
          name: 'positionIndex',
          type: 'number',
          default: 0
        },
        "screensPerPlay": {
          name: 'screensPerPlay',
          type: 'number',
          default: 1
        },
        "dwellTime": {
          name: 'dwellTime',
          type: 'number',
          default: 10
        },
        "transition": {
          name: 'transition',
          type: 'string',
          default: ''
        },
        "triggerable": {
          name: 'triggerable',
          type: 'boolean',
          default: false
        },
        "inScheduleWhenTriggerEnabled": {
          name: 'inScheduleWhenTriggerEnabled',
          type: 'boolean',
          default: false
        },
        "conditions": {
          name: 'conditions',
          type: 'any',
          default: <any>null
        },
        "metadata": {
          name: 'metadata',
          type: 'any'
        },
        "screenCategoryId": {
          name: 'screenCategoryId',
          type: 'string'
        },
        "ownerScreenCategoryId": {
          name: 'ownerScreenCategoryId',
          type: 'string'
        },
        "screenId": {
          name: 'screenId',
          type: 'string'
        },
        "categoryRotationId": {
          name: 'categoryRotationId',
          type: 'string'
        },
        "createdByIp": {
          name: 'createdByIp',
          type: 'string'
        },
        "lastUpdatedByIp": {
          name: 'lastUpdatedByIp',
          type: 'string'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "layoutPanelId": {
          name: 'layoutPanelId',
          type: 'string'
        },
        "layoutPanelOverlayId": {
          name: 'layoutPanelOverlayId',
          type: 'string'
        },
      },
      relations: {
        screenCategory: {
          name: 'screenCategory',
          type: 'ScreenCategory',
          model: 'ScreenCategory',
          relationType: 'belongsTo',
                  keyFrom: 'screenCategoryId',
          keyTo: 'id'
        },
        ownerScreenCategory: {
          name: 'ownerScreenCategory',
          type: 'ScreenCategory',
          model: 'ScreenCategory',
          relationType: 'belongsTo',
                  keyFrom: 'ownerScreenCategoryId',
          keyTo: 'id'
        },
        screen: {
          name: 'screen',
          type: 'Screen',
          model: 'Screen',
          relationType: 'belongsTo',
                  keyFrom: 'screenId',
          keyTo: 'id'
        },
        scheduleTimeframes: {
          name: 'scheduleTimeframes',
          type: 'ScheduleTimeframe[]',
          model: 'ScheduleTimeframe',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'rotationItemId'
        },
        categoryRotation: {
          name: 'categoryRotation',
          type: 'CategoryRotation',
          model: 'CategoryRotation',
          relationType: 'belongsTo',
                  keyFrom: 'categoryRotationId',
          keyTo: 'id'
        },
        layoutPanel: {
          name: 'layoutPanel',
          type: 'LayoutPanel',
          model: 'LayoutPanel',
          relationType: 'belongsTo',
                  keyFrom: 'layoutPanelId',
          keyTo: 'id'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sdk/models/RotationItem.ts